export default __webpack_public_path__ + "static/media/04-RAKESH ARAVIND.c40fd1f0.jpg";